
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const UnionConfig = ({ data, onChange }: any) => {
    return (
        <div className="space-y-4">
            <div className="space-y-2">
                <Label>Union Type</Label>
                <Select value={data.union_type || 'ALL'} onValueChange={(v) => onChange('union_type', v)}>
                    <SelectTrigger>
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="bg-white z-50 shadow-lg border-gray-200">
                        <SelectItem value="ALL">Union All (Keep Duplicates)</SelectItem>
                        <SelectItem value="DISTINCT">Union Distinct (Remove Duplicates)</SelectItem>
                    </SelectContent>
                </Select>
            </div>

            <div className="flex items-center space-x-2 border p-3 rounded bg-gray-50">
                <input
                    type="checkbox"
                    className="rounded border-gray-300 text-violet-600 focus:ring-violet-500 h-4 w-4"
                    checked={data.by_name !== false} // Default true
                    onChange={(e) => onChange('by_name', e.target.checked)}
                />
                <div>
                    <Label className="font-semibold text-gray-700">Match by Name</Label>
                    <div className="text-xs text-gray-500">If checked, columns are matched by name. Unchecked matches by position.</div>
                </div>
            </div>
        </div>
    );
};
